import {showInfoToast} from "./validation/ToastContainer";
const DEBUG_ENABLED = true;

export function randomDomId() {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return `${s4() + s4()}`;
}

export function randomInt(max) {
    return Math.floor(Math.random() * Math.floor(max));
}

export function debug(message, ...args) {
    if (DEBUG_ENABLED) {
        console.debug(message, args);
    }
}

export function info(message, ...args) {
    console.info(message, args);
}

export function warn(message, ...args) {
    console.warn(message, args);
}

export function debugAndReturn(message, returnedObject) {
    if (DEBUG_ENABLED) {
        console.debug(message, returnedObject);
    }
    return returnedObject;
}

export function parseTimestampToReadableDateAndTime(timestamp) {
    const isoParts = new Date(Number(timestamp)).toISOString().split('T');
    isoParts[1] = isoParts[1].substring(0, isoParts[1].length - 5);
    return {
        date: isoParts[0],
        time: isoParts[1]
    }
}

export const convertToDateFormat = (value) => {
    let dateParts = value.split("-");
    let year = dateParts[0];
    let month = dateParts[1];
    let day = dateParts[2];
    return `${month}/${day}/${year}`;
};

export const convertMLDateTimeToDateFormat = (value) => {
    let date = value.split(" ");
    let dateParts = date[0].split("-");
    let year = dateParts[0];
    let month = dateParts[1];
    let day = dateParts[2];
    return `${month}/${day}/${year}`;
};


export function timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function deepCopy(data) {
    // alert (JSON.stringify(data));
    return JSON.parse(JSON.stringify(data));
}

export function deepEquals(obj1, obj2) {
    return obj1 === obj2 || JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function stubAsyncCall(response, error) {
    return error ? Promise.reject(response) : Promise.resolve(response);
}

export function chunkArray(array, chunkSize) {
    let results = [];
    while (array.length) {
        results.push(array.splice(0, chunkSize));
    }
    return results;
}

export function notImplemented() {
    showInfoToast("It is not implemented yet");
}

export function noPermission() {
    showInfoToast("You have no permission!");
}
export function hasErrors(errors) {
    return Object.values(errors).filter(err => !!err).length > 0;
}

export function reverseString(str) {
    return [...str].reverse().join('');
}

export const objectToUrlEncodedString = (obj) => {
    return Object.keys(obj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])).join('&');
}

export const sortByAlphabet = (a, b) => a.localeCompare(b);

export const sortObjectsByAlphabet = (array, propName) => {

    if (array && Array.isArray(array)) {
        const result = deepCopy(array);
        result.sort((a, b) => a[propName].localeCompare(b[propName]));
        return result
    } else {
        return array;
    }
}

export const sortArrayByAlphabetDESC = (array) => {

    if (array && Array.isArray(array)) {
        const result = deepCopy(array);
        result.sort((a, b) => b.localeCompare(a));
        return result
    } else {
        return array;
    }
}

export const sortConfigFilesArrayDESC = (array) => {
    if (array && Array.isArray(array)) {        
        // return sortFilesByDateTimeDesc(array);
        return array.sort((a, b) => {
            const x = a.split('@')[1].split('.')[0]
            const xint = x.split('_')[0] + ' ' + x.split('_')[1];
            const dateTimeA = new Date(`${xint}`);
    
            const y = b.split('@')[1].split('.')[0]
            const yint = y.split('_')[0] + ' ' + y.split('_')[1];
            const dateTimeB = new Date(`${yint}`);
    
            return dateTimeB - dateTimeA;
        });

    } else {
        return array;
    }
}

// const sortFilesByDateTimeDesc = (filesArray) => {
//     return filesArray.sort((a, b) => {
//         const x = a.split('@')[1].split('.')[0]
//         const xint = x.split('_')[0] + ' ' + x.split('_')[1];
//         const dateTimeA = new Date(`${xint}`);

//         const y = b.split('@')[1].split('.')[0]
//         const yint = y.split('_')[0] + ' ' + y.split('_')[1];
//         const dateTimeB = new Date(`${yint}`);

//         return dateTimeB - dateTimeA;
//     });
// };
  

export function getDateInLogFormat(date = new Date()) {
    let month = '' + (date.getMonth() + 1);
    let day = '' + date.getDate();
    const year = date.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
}

export const getCompliance = (pci, cis) => (pci + cis) / 2;

// Format date for reports table: "24 Sep 2025, 21:49"
export function formatReportDate(dateString) {
    if (!dateString) return '';

    const date = new Date(dateString);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day} ${month} ${year}, ${hours}:${minutes}`;
}

export function formatMlDetectionDate(dateString) {
    if (!dateString) {
        return {
            displayDate: '',
            displayTime: '',
            displayDateTime: '',
            raw: '',
        };
    }

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return {
            displayDate: String(dateString),
            displayTime: '',
            displayDateTime: String(dateString),
            raw: String(dateString),
        };
    }

    const displayDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });

    const displayTime = date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZoneName: "short",
    });

    return {
        displayDate,
        displayTime,
        displayDateTime: `${displayDate}, ${displayTime}`,
        raw: String(dateString),
    };
}

// Get initials from name for avatar badge
export function getInitials(name) {
    if (!name) return '';
    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
